/**
 * Venta (Sell Out) Service
 * Consume los endpoints del modulo Venta, que leen la tabla
 * cantabria_labs_prod.sell_in_sell_out en Athena. Backend: routes/sellout.py
 *
 * El periodo va en YYYYMM y NO en YYYY-MM-DD: el dato es mensual (una fila por
 * cadena/sucursal/SKU/mes), asi que un filtro por dia no tendria a que aplicarse.
 */

const API_URL = process.env.REACT_APP_STRANDS_API_URL || 'http://localhost:5001';

async function getJson(path) {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    let msg = `Error ${res.status}`;
    try {
      const e = await res.json();
      msg = e.error || msg;
    } catch (_) { /* respuesta sin JSON */ }
    throw new Error(msg);
  }
  return res.json();
}

/** ?from=YYYYMM&to=YYYYMM(&cliente=&marca=&limit=), ignorando valores vacios. */
function qs(range = {}, extra = {}) {
  const p = new URLSearchParams();
  if (range.from) p.set('from', range.from);
  if (range.to) p.set('to', range.to);
  Object.entries(extra).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.set(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : '';
}

// ── Global: periodo disponible + catalogos de filtro ─────────────────────────
export const getSelloutBounds = () => getJson('/api/sellout/bounds');

// ── Resumen ──────────────────────────────────────────────────────────────────
export const getSelloutOverview = (range, f = {}) =>
  getJson(`/api/sellout/overview${qs(range, { cliente: f.cliente, marca: f.marca })}`);

// ── Cadenas (no acepta filtro de cadena: compara unas contra otras) ──────────
export const getSelloutChains = (range, f = {}) =>
  getJson(`/api/sellout/chains${qs(range, { marca: f.marca })}`);

// ── Producto ─────────────────────────────────────────────────────────────────
export const getSelloutProducts = (range, f = {}, limit = 20) =>
  getJson(`/api/sellout/products${qs(range, { cliente: f.cliente, marca: f.marca, limit })}`);

// ── Tiendas ──────────────────────────────────────────────────────────────────
export const getSelloutStores = (range, f = {}, limit = 15) =>
  getJson(`/api/sellout/stores${qs(range, { cliente: f.cliente, marca: f.marca, limit })}`);
